"use strict";
// DO NOT EDIT THIS FILE!
// This file was generated by UBI-generators.
// For support contact us on the #ubi slack channel.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSupportChatWindowEventFactory = exports.createWebSupportChatWindowEventFactory = void 0;
var SPECIFICATION_ID = "web-support-chat-window";
var APP = "support-spotify-com";
var SPECIFICATION_VERSION = "4.0.0";
var SPECIFICATION_MODE = "default";
var GENERATOR_VERSION = "10.0.1";
function createWebSupportChatWindowEventFactory(options) {
    return new WebSupportChatWindowEventFactory(options);
}
exports.createWebSupportChatWindowEventFactory = createWebSupportChatWindowEventFactory;
/**
 * Spec for support chat window
 */
var WebSupportChatWindowEventFactory = /** @class */ (function () {
    function WebSupportChatWindowEventFactory(options) {
        this._path = [__assign({ name: SPECIFICATION_ID }, options.data)];
        if (options === null || options === void 0 ? void 0 : options.parentAbsoluteLocation) {
            this._parentAbsoluteLocation = options.parentAbsoluteLocation;
        }
    }
    /**
    * @returns A new instance of CustomerMessageEventFactory
    */
    WebSupportChatWindowEventFactory.prototype.customerMessageFactory = function () {
        return new WebSupportChatWindowEventFactory.CustomerMessageEventFactory({
            path: this._path,
            parentAbsoluteLocation: this._parentAbsoluteLocation
        });
    };
    /**
    * @param id of the BotMessageEventFactory
    * @returns A new instance of BotMessageEventFactory
    */
    WebSupportChatWindowEventFactory.prototype.botMessageFactory = function (data) {
        return new WebSupportChatWindowEventFactory.BotMessageEventFactory({
            path: this._path,
            parentAbsoluteLocation: this._parentAbsoluteLocation,
            data: data
        });
    };
    /**
    * @param id of the AdvisorMessageEventFactory
    * @returns A new instance of AdvisorMessageEventFactory
    */
    WebSupportChatWindowEventFactory.prototype.advisorMessageFactory = function (data) {
        return new WebSupportChatWindowEventFactory.AdvisorMessageEventFactory({
            path: this._path,
            parentAbsoluteLocation: this._parentAbsoluteLocation,
            data: data
        });
    };
    WebSupportChatWindowEventFactory.prototype._getCurrentLocation = function () {
        return {
            pathNodes: this._path,
            specMode: __spreadArrays([SPECIFICATION_MODE], __spreadArrays(Array(this._path.length - 1)).map(function () { return ''; })),
            specVersion: __spreadArrays([SPECIFICATION_VERSION], __spreadArrays(Array(this._path.length - 1)).map(function () { return ''; }))
        };
    };
    WebSupportChatWindowEventFactory.prototype.getAbsoluteLocation = function () {
        var _a;
        var parentLocations = (_a = this._parentAbsoluteLocation) === null || _a === void 0 ? void 0 : _a.locations;
        return {
            locations: __spreadArrays((parentLocations || []), [
                this._getCurrentLocation()
            ]),
        };
    };
    /**
     * Create impression for WebSupportChatWindowEventFactory.
     */
    WebSupportChatWindowEventFactory.prototype.impression = function () {
        var data = {
            app: APP,
            generatorVersion: GENERATOR_VERSION,
            specificationVersion: SPECIFICATION_VERSION,
            specificationMode: SPECIFICATION_MODE,
            annotatorConfigurationVersion: '',
            annotatorVersion: '',
            location: this._getCurrentLocation(),
            parentAbsoluteLocation: this._parentAbsoluteLocation
        };
        return data;
    };
    return WebSupportChatWindowEventFactory;
}());
exports.WebSupportChatWindowEventFactory = WebSupportChatWindowEventFactory;
(function (WebSupportChatWindowEventFactory) {
    /**
     * Create CustomerMessageEventFactory class with path
     * @param path to this node
     */
    var CustomerMessageEventFactory = /** @class */ (function () {
        function CustomerMessageEventFactory(_a) {
            var path = _a.path, parentAbsoluteLocation = _a.parentAbsoluteLocation, data = _a.data;
            this._path = path.concat({
                name: "customer_message"
            });
            if (parentAbsoluteLocation) {
                this._parentAbsoluteLocation = parentAbsoluteLocation;
            }
        }
        CustomerMessageEventFactory.prototype._getCurrentLocation = function () {
            return {
                pathNodes: this._path,
                specMode: __spreadArrays([SPECIFICATION_MODE], __spreadArrays(Array(this._path.length - 1)).map(function () { return ''; })),
                specVersion: __spreadArrays([SPECIFICATION_VERSION], __spreadArrays(Array(this._path.length - 1)).map(function () { return ''; }))
            };
        };
        CustomerMessageEventFactory.prototype.getAbsoluteLocation = function () {
            var _a;
            var parentLocations = (_a = this._parentAbsoluteLocation) === null || _a === void 0 ? void 0 : _a.locations;
            return {
                locations: __spreadArrays((parentLocations || []), [
                    this._getCurrentLocation()
                ]),
            };
        };
        /**
         * Create interaction for hit send_message action.
         */
        CustomerMessageEventFactory.prototype.hitSendMessage = function () {
            var data = {
                actionName: "send_message",
                actionVersion: 1,
                app: APP,
                generatorVersion: GENERATOR_VERSION,
                interactionType: "hit",
                specificationMode: SPECIFICATION_MODE,
                specificationVersion: SPECIFICATION_VERSION,
                annotatorConfigurationVersion: '',
                annotatorVersion: '',
                location: this._getCurrentLocation(),
                parentAbsoluteLocation: this._parentAbsoluteLocation
            };
            return data;
        };
        return CustomerMessageEventFactory;
    }());
    WebSupportChatWindowEventFactory.CustomerMessageEventFactory = CustomerMessageEventFactory;
})(WebSupportChatWindowEventFactory = exports.WebSupportChatWindowEventFactory || (exports.WebSupportChatWindowEventFactory = {}));
exports.WebSupportChatWindowEventFactory = WebSupportChatWindowEventFactory;
(function (WebSupportChatWindowEventFactory) {
    /**
     * Create BotMessageEventFactory class with path
     * @param path to this node
     */
    var BotMessageEventFactory = /** @class */ (function () {
        function BotMessageEventFactory(_a) {
            var path = _a.path, parentAbsoluteLocation = _a.parentAbsoluteLocation, data = _a.data;
            this._path = path.concat(__assign(__assign({}, data), { name: "bot_message" }));
            if (parentAbsoluteLocation) {
                this._parentAbsoluteLocation = parentAbsoluteLocation;
            }
        }
        /**
        * @param id of the BotQuickReplyEventFactory
        * @param position of the BotQuickReplyEventFactory
        * @returns A new instance of BotQuickReplyEventFactory
        */
        BotMessageEventFactory.prototype.botQuickReplyFactory = function (data) {
            return new WebSupportChatWindowEventFactory.BotMessageEventFactory.BotQuickReplyEventFactory({
                path: this._path,
                parentAbsoluteLocation: this._parentAbsoluteLocation,
                data: data
            });
        };
        BotMessageEventFactory.prototype._getCurrentLocation = function () {
            return {
                pathNodes: this._path,
                specMode: __spreadArrays([SPECIFICATION_MODE], __spreadArrays(Array(this._path.length - 1)).map(function () { return ''; })),
                specVersion: __spreadArrays([SPECIFICATION_VERSION], __spreadArrays(Array(this._path.length - 1)).map(function () { return ''; }))
            };
        };
        BotMessageEventFactory.prototype.getAbsoluteLocation = function () {
            var _a;
            var parentLocations = (_a = this._parentAbsoluteLocation) === null || _a === void 0 ? void 0 : _a.locations;
            return {
                locations: __spreadArrays((parentLocations || []), [
                    this._getCurrentLocation()
                ]),
            };
        };
        /**
         * Create impression for BotMessageEventFactory.
         */
        BotMessageEventFactory.prototype.impression = function () {
            var data = {
                app: APP,
                generatorVersion: GENERATOR_VERSION,
                specificationVersion: SPECIFICATION_VERSION,
                specificationMode: SPECIFICATION_MODE,
                annotatorConfigurationVersion: '',
                annotatorVersion: '',
                location: this._getCurrentLocation(),
                parentAbsoluteLocation: this._parentAbsoluteLocation
            };
            return data;
        };
        return BotMessageEventFactory;
    }());
    WebSupportChatWindowEventFactory.BotMessageEventFactory = BotMessageEventFactory;
})(WebSupportChatWindowEventFactory = exports.WebSupportChatWindowEventFactory || (exports.WebSupportChatWindowEventFactory = {}));
exports.WebSupportChatWindowEventFactory = WebSupportChatWindowEventFactory;
(function (WebSupportChatWindowEventFactory) {
    /**
     * Create AdvisorMessageEventFactory class with path
     * @param path to this node
     */
    var AdvisorMessageEventFactory = /** @class */ (function () {
        function AdvisorMessageEventFactory(_a) {
            var path = _a.path, parentAbsoluteLocation = _a.parentAbsoluteLocation, data = _a.data;
            this._path = path.concat(__assign(__assign({}, data), { name: "advisor_message" }));
            if (parentAbsoluteLocation) {
                this._parentAbsoluteLocation = parentAbsoluteLocation;
            }
        }
        AdvisorMessageEventFactory.prototype._getCurrentLocation = function () {
            return {
                pathNodes: this._path,
                specMode: __spreadArrays([SPECIFICATION_MODE], __spreadArrays(Array(this._path.length - 1)).map(function () { return ''; })),
                specVersion: __spreadArrays([SPECIFICATION_VERSION], __spreadArrays(Array(this._path.length - 1)).map(function () { return ''; }))
            };
        };
        AdvisorMessageEventFactory.prototype.getAbsoluteLocation = function () {
            var _a;
            var parentLocations = (_a = this._parentAbsoluteLocation) === null || _a === void 0 ? void 0 : _a.locations;
            return {
                locations: __spreadArrays((parentLocations || []), [
                    this._getCurrentLocation()
                ]),
            };
        };
        /**
         * Create impression for AdvisorMessageEventFactory.
         */
        AdvisorMessageEventFactory.prototype.impression = function () {
            var data = {
                app: APP,
                generatorVersion: GENERATOR_VERSION,
                specificationVersion: SPECIFICATION_VERSION,
                specificationMode: SPECIFICATION_MODE,
                annotatorConfigurationVersion: '',
                annotatorVersion: '',
                location: this._getCurrentLocation(),
                parentAbsoluteLocation: this._parentAbsoluteLocation
            };
            return data;
        };
        return AdvisorMessageEventFactory;
    }());
    WebSupportChatWindowEventFactory.AdvisorMessageEventFactory = AdvisorMessageEventFactory;
})(WebSupportChatWindowEventFactory = exports.WebSupportChatWindowEventFactory || (exports.WebSupportChatWindowEventFactory = {}));
exports.WebSupportChatWindowEventFactory = WebSupportChatWindowEventFactory;
(function (WebSupportChatWindowEventFactory) {
    var BotMessageEventFactory;
    (function (BotMessageEventFactory) {
        /**
         * Create BotQuickReplyEventFactory class with path
         * @param path to this node
         */
        var BotQuickReplyEventFactory = /** @class */ (function () {
            function BotQuickReplyEventFactory(_a) {
                var path = _a.path, parentAbsoluteLocation = _a.parentAbsoluteLocation, data = _a.data;
                this._path = path.concat(__assign(__assign({}, data), { name: "bot_quick_reply" }));
                if (parentAbsoluteLocation) {
                    this._parentAbsoluteLocation = parentAbsoluteLocation;
                }
            }
            BotQuickReplyEventFactory.prototype._getCurrentLocation = function () {
                return {
                    pathNodes: this._path,
                    specMode: __spreadArrays([SPECIFICATION_MODE], __spreadArrays(Array(this._path.length - 1)).map(function () { return ''; })),
                    specVersion: __spreadArrays([SPECIFICATION_VERSION], __spreadArrays(Array(this._path.length - 1)).map(function () { return ''; }))
                };
            };
            BotQuickReplyEventFactory.prototype.getAbsoluteLocation = function () {
                var _a;
                var parentLocations = (_a = this._parentAbsoluteLocation) === null || _a === void 0 ? void 0 : _a.locations;
                return {
                    locations: __spreadArrays((parentLocations || []), [
                        this._getCurrentLocation()
                    ]),
                };
            };
            /**
             * Create interaction for hit pick_quick_reply action.
             */
            BotQuickReplyEventFactory.prototype.hitPickQuickReply = function () {
                var data = {
                    actionName: "pick_quick_reply",
                    actionVersion: 1,
                    app: APP,
                    generatorVersion: GENERATOR_VERSION,
                    interactionType: "hit",
                    specificationMode: SPECIFICATION_MODE,
                    specificationVersion: SPECIFICATION_VERSION,
                    annotatorConfigurationVersion: '',
                    annotatorVersion: '',
                    location: this._getCurrentLocation(),
                    parentAbsoluteLocation: this._parentAbsoluteLocation
                };
                return data;
            };
            /**
             * Create impression for BotQuickReplyEventFactory.
             */
            BotQuickReplyEventFactory.prototype.impression = function () {
                var data = {
                    app: APP,
                    generatorVersion: GENERATOR_VERSION,
                    specificationVersion: SPECIFICATION_VERSION,
                    specificationMode: SPECIFICATION_MODE,
                    annotatorConfigurationVersion: '',
                    annotatorVersion: '',
                    location: this._getCurrentLocation(),
                    parentAbsoluteLocation: this._parentAbsoluteLocation
                };
                return data;
            };
            return BotQuickReplyEventFactory;
        }());
        BotMessageEventFactory.BotQuickReplyEventFactory = BotQuickReplyEventFactory;
    })(BotMessageEventFactory = WebSupportChatWindowEventFactory.BotMessageEventFactory || (WebSupportChatWindowEventFactory.BotMessageEventFactory = {}));
})(WebSupportChatWindowEventFactory = exports.WebSupportChatWindowEventFactory || (exports.WebSupportChatWindowEventFactory = {}));
exports.WebSupportChatWindowEventFactory = WebSupportChatWindowEventFactory;
